module.exports = __webpack_public_path__ + "static/media/Test49.92505934.bmp";